import { useEffect, useState } from "react";

import { useAtomValue } from "../app-jotai";

import { determineWhiteboardMode } from "../components/premissions/permissions";

import { roomMetadataAtom, userinfoAtom } from "./channel_state_jotai";

import type { ExcalidrawImperativeAPI } from "../../packages/excalidraw/types";

export const useIsViewMode = (
  excalidrawAPI: ExcalidrawImperativeAPI | null,
) => {
  const roomMetadata = useAtomValue(roomMetadataAtom);
  const { metadata: userMetadata, isRecorder } = useAtomValue(userinfoAtom);
  const [isViewMode, setIsViewMode] = useState(false);
  useEffect(() => {
    const viewMode = determineWhiteboardMode({
      isAdmin: userMetadata.is_admin,
      isPresenter: userMetadata.is_presenter,
      userLockedWhiteboard: userMetadata.lock_settings.lock_whiteboard,
      roomLockedWhiteboard: roomMetadata.default_lock_settings?.lock_whiteboard,
      isUserRecorder: isRecorder,
    });

    console.log("View mode:", viewMode, {
      isAdmin: userMetadata.is_admin,
      isPresenter: userMetadata.is_presenter,
      userLockedWhiteboard: userMetadata.lock_settings.lock_whiteboard,
      roomLockedWhiteboard:
        roomMetadata.room_features.whiteboard_features.allowed_whiteboard,
      isUserRecorder: isRecorder,
    });
    setIsViewMode(viewMode);
  }, [roomMetadata, userMetadata, excalidrawAPI, isRecorder]);

  return { isViewMode };
};
